import { Injectable } from '@angular/core';

import { environment } from './../../environments/environment';
import { LovDataLocal } from './../data/mock-data';
import { HttpService } from './http.service';

@Injectable()
export class LovDataHttp {
  constructor(protected httpService: HttpService) {}

  async getAllData() {
    return this.httpService.get('/lov-data');
  }

  async getBanksData() {
    return this.httpService.get('/lov-data/banks');
  }
  async getBranchesData(bankId) {
    return this.httpService.get(`/lov-data/branches?bankId=${bankId}`);
  }
  async getBankHolidays() {
    return this.httpService.get('/ut-request/bank-holidays');
  }
}

@Injectable()
export class LovDataService {
  private allData;
  private allDataLoadingPromise;
  private banksData;
  private banksDataLoadingPromise;
  constructor(protected http: LovDataHttp) {}

  async getAllData() {
    if (this.allDataLoadingPromise) {
      return this.allDataLoadingPromise;
    }
    this.allDataLoadingPromise = this.http.getAllData();
    this.allData = await this.allDataLoadingPromise;
    if (environment.dev) {
      this.allData.Local = Object.assign(LovDataLocal, this.allData.Local);
    } else {
      this.allData = await this.allDataLoadingPromise;
    }
    this.allDataLoadingPromise = undefined;
  }

  async loadBanksData() {
    return await this.http.getBanksData();
  }
  async loadBranchesData(bankId) {
    return await this.http.getBranchesData(bankId);
  }
  async getDataSet(dataPath: String) {
    if (!this.allData) {
      await this.getAllData();
    }
    const dataPaths = dataPath.split('.');
    const data = dataPaths.reduce((narrowedDataSet, pathItem, i) => narrowedDataSet[pathItem], this.allData);
    return Object.keys(data).map((k) => {
      return { id: k, text: data[k] };
    });
  }
  async getCountryData(dataPath: String) {
    if (!this.allData) {
      await this.getAllData();
    }
    const dataPaths = dataPath.split('.');
    const data = dataPaths.reduce((narrowedDataSet, pathItem, i) => narrowedDataSet[pathItem], this.allData);
    return Object.keys(data).map((k) => {
      return { id: data[k], text: data[k] };
    });
  }

  async getBankHolidays() {
    return await this.http.getBankHolidays();
  }
}
